import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchSamplers({ payload }) {
  try {
    const { page = 1, limit = 10, filters } = payload || {};
    let finalQuery = `page=${page}&limit=${limit}`;

    // apply filters dynamically
    if (filters?.state) {
      filters.state.forEach((cat) => {
        finalQuery += `&stateId=${cat}`;
      });
    }

    if (filters?.agency) {
      filters.agency.forEach((cat) => {
        finalQuery += `&agencyId=${cat}`;
      });
    }

    if (filters?.district) {
      filters.district.forEach((cat) => {
        finalQuery += `&districtId=${cat}`;
      });
    }

    const res = yield call(API.fetchAllSamplers, { query: finalQuery });
    const { data } = res;

    yield put(actions.fetchSamplersSuccess(data));
  } catch (err) {
    yield put(actions.fetchSamplersFailure(err?.response?.data));
  }
}

export function* handleFetchStates({ payload }) {
  try {
    const res = yield call(API.fetchAllStates, payload);
    const { data } = res;
    yield put(actions.fetchStatesSuccess(data));
  } catch (err) {
    yield put(actions.fetchStatesFailure(err?.response?.data));
  }
}

export function* handleFetchDistricts({ payload }) {
  try {
    const res = yield call(API.fetchDistrictsForState, payload);
    const { data } = res;
    yield put(actions.fetchDistrictsSuccess(data));
  } catch (err) {
    yield put(actions.fetchDistrictsFailure(err?.response?.data));
  }
}

export function* handleAddSampler({ payload }) {
  try {
    const res = yield call(API.addSampler, payload);
    const { data } = res;
    yield put(actions.fetchSamplers({ page: 1, limit: 10, filters: {} }));
    yield put(actions.addSamplerSuccess(data));
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(actions.addSamplerFailure(err?.response?.data));
    if (payload.onFailure) {
      payload.onFailure(err?.response?.data);
    }
  }
}

export function* handleEditSampler({ payload }) {
  try {
    const res = yield call(API.editSampler, payload);
    const { data } = res;
    yield put(actions.fetchSamplers({ query: `page=1&limit=10` }));
    yield put(actions.editSamplerSuccess(data));
  } catch (err) {
    yield put(actions.editSamplerFailure(err?.response?.data));
  }
}

export function* handleFetchAgencies({ payload }) {
  try {
    const res = yield call(API.fetchAllAgencies, payload);
    const { data } = res;
    yield put(actions.fetchAgenciesSuccess(data));
  } catch (err) {
    yield put(actions.fetchAgenciesFailure(err?.response?.data));
  }
}

export function* handleFetchDistrictsOfMultipleStates({ payload }) {
  try {
    const res = yield call(API.fetchDistrictsOfMultipleStates, payload);
    const { data } = res;
    yield put(actions.fetchDistrictsOfMultipleStatesSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.fetchDistrictsOfMultipleStatesFailure(err?.response?.data));
    payload.onFailure();
  }
}
/**
 * Root saga manages watcher lifecycle
 */
export function* samplerListingSaga() {
  yield takeLatest(actions.fetchSamplers.type, handleFetchSamplers);
  yield takeLatest(actions.fetchStates.type, handleFetchStates);
  yield takeLatest(actions.fetchDistricts.type, handleFetchDistricts);
  yield takeLatest(actions.addSampler.type, handleAddSampler);
  yield takeLatest(actions.editSampler.type, handleEditSampler);
  yield takeLatest(actions.fetchAgencies.type, handleFetchAgencies);
  yield takeLatest(actions.fetchDistrictsOfMultipleStates.type, handleFetchDistrictsOfMultipleStates);
}